export default {
  createSuccess: "Agente di commercio creato con successo!",
  scopeAssigned: "Assegnazione salvata",
  scopeRemoved: "Assegnazione rimossa",
  removeScopeError: "Impossibile rimuovere l’assegnazione",
  create: {
    title: "Crea agente di commercio",
    namePlaceholder: "Nome visualizzato",
    emailPlaceholder: "agente@example.com",
    submit: "Crea",
  },
  detail: {
    invalidRoute: "Percorso non valido.",
    roleLabel: "Agente di commercio",
    statAssociations: "Utenti associati",
    loadDetail: "Caricamento dettagli agente...",
    loadError: "Impossibile caricare l’agente di commercio",
    toastStatusUpdated: "Stato agente aggiornato",
    toastStatusError: "Impossibile aggiornare lo stato dell’agente",
    scopedHelp:
      "Assegna questo agente ad attività o strutture specifiche con una commissione.",
    activitySection: "Attività",
    houseSection: "Strutture",
    addActivity: "Assegna attività",
    addHouse: "Assegna struttura",
    colActivity: "Attività",
    colHouse: "Struttura",
    colOwner: "Proprietario",
    colHost: "Host",
    colSaRate: "Quota agente",
    emptyActivities: "Nessuna attività assegnata.",
    emptyHouses: "Nessuna struttura assegnata.",
    remove: "Rimuovi",
    removeConfirmActivity:
      "Rimuovere l’assegnazione dell’agente di commercio per questa attività?",
    removeConfirmHouse:
      "Rimuovere l’assegnazione dell’agente di commercio per questa struttura?",
    modalActivityTitle: "Assegna attività",
    modalActivitySubtitle:
      "Scegli un’attività e imposta la commissione che questo agente percepisce sulle prenotazioni di quell’attività.",
    modalHouseTitle: "Assegna struttura",
    modalHouseSubtitle:
      "Scegli una struttura e imposta la commissione che questo agente percepisce sulle prenotazioni di quella struttura.",
    selectActivityStep: "Seleziona attività",
    selectStructureStep: "Seleziona struttura",
    searchActivitiesPlaceholder: "Cerca per attività o nome proprietario…",
    searchStructuresPlaceholder: "Cerca per struttura o nome proprietario…",
    noActivitiesFound: "Nessuna attività trovata.",
    noStructuresFound: "Nessuna struttura trovata.",
    saCommissionPercentLabel: "Commissione agente (%)",
    invalidCommission: "Inserisci una commissione valida.",
  },
  associations: {
    title: "Le tue assegnazioni",
    description:
      "Ogni riga è un’attività o una struttura a cui sei assegnato, con la tua percentuale",
    loading: "Caricamento assegnazioni...",
    errorLoad: "Impossibile caricare le assegnazioni",
    colName: "Attività / struttura",
    colOwner: "Proprietario",
    colRate: "La tua quota",
    scopeActivity: "Attività",
    scopeHouse: "Struttura",
    statActivities: "Attività",
    statHouses: "Strutture",
    statTopRate: "Quota più alta",
    empty:
      "Nessuna assegnazione. Contatta lo staff per collegare il tuo account ad attività o strutture.",
  },
} as const;
